export default __webpack_public_path__ + "static/media/19.63577f96.png";